export const QUICK_SEARCH_ID = 'quick-search';
